<template>
  <div class="full-height">
    <v-container fluid class="pa-0">
      <v-banner min-height="77"  color="surface" class="d-flex align-center border-0 justify-center">
        <v-row>
          <v-col cols="12" class="text-center lh-base d-flex flex-column align-center justify-center">
            <h4 class="on-surface text-h4 lh-base font-weight-medium">
              Now you know your Potential Retirement Tax Bill!
              <v-icon small class="text-on-surface mr-2">$iconCalculator</v-icon>
            </h4>
            <h4 class="on-surface text-h4 lh-base font-weight-medium mt-5">Our team is here to help!</h4>
          </v-col>
        </v-row>
      </v-banner>

      <v-sheet min-height="800px" id="leadGenHero" class="fill-height pa-5 d-flex align-center justify-stretch" :style="heroBackgroundStyle">
        <v-container>
          <v-row align="stretch">
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6">
                  <CalcCardCondense :isCalculated="false" />
                </v-col>
                <v-col cols="12" md="6">
                  <CalcCardCondense :isCalculated="true" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="10" offset-sm="1" md="6" offset-md="3" style="overflow: visible;">
                  <v-card variant="flat" rounded="0" elevation="6" class="surface mx-auto my-4 fill-height">
                    <v-card-title class="text-center d-flex justify-center pa-3 pa-md-4">
                      <span class="text-h5 text-sm-h4 text-md-h3 text-wrap lh-base font-weight-bold on-surface">
                        Potential Tax Difference <br /> Between Approaches
                      </span>
                    </v-card-title>

                    <v-card-text class="pt-4 px-6 text-center d-flex">
                      <v-row>
                        <v-col cols="12" class="bg-background elevation-10">
                          <span class="text-h3 text-sm-h2 text-md-h1 text-on-background">{{ formatCurrency(store.user.taxPaid - store.user.totalTaxesConversion) }}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="mt-10">
                <v-col class="text-center" cols="12" md="6" offset-md="3">
                  <v-btn rounded="pill" block class="multi-line" @click="scheduleAction" color="primary" size="x-large">
                    <h3 class="font-weight-medium text-on-primary">Review your results with a Financial Professional</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>

      <v-banner min-height="77"  class="d-flex align-center border-0 justify-center bg-surface-light">
        <v-row>
          <v-col cols="12" class="text-center">
            <h4 class="text-on-surface-light text-h4 font-weight-medium my-3">
              Here are your next 3 steps:
            </h4>
          </v-col>
        </v-row>
      </v-banner>

      <v-sheet min-height="410px" class="fill-height bg-background d-flex align-center justify-center">
        <v-container class="py-10">
          <v-row class="py-0">
            <v-col cols="12" md="3" class="text-center py-5">
              <v-icon class="constraint150by100 text-secondary pb-15">$iconReview</v-icon>
              <h2 class="font-weight-medium text-h2 text-on-surface">Review Your Results</h2>
              <h3 class="font-weight-light text-on-surface text-h4 mt-3">Now, you can see the potential taxes with your existing approach - and your potential taxes with an adjusted approach.</h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="text-center py-5">
              <v-icon class="constraint150by100 text-secondary pb-15">$iconConsider</v-icon>
              <h2 class="font-weight-medium text-h2 text-on-surface">Consider Your Options</h2>
              <h3 class="font-weight-light text-on-surface text-h4 mt-3">You may have options to reduce your tax bill in retirement. Learn more now.</h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="text-center py-5">
              <v-icon class="constraint150by120 text-secondary pb-15">$iconCheck</v-icon>
              <h2 class="font-weight-medium text-h2 text-on-surface">Check Your Inbox</h2>
              <h3 class="font-weight-light text-on-surface text-h4 mt-3">Check your email to review your complete report. Don't see your report in your inbox? Schedule a call and we'll review it.</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center" cols="12" md="8" offset-md="2">
              <v-btn size="x-large" @click="scheduleAction" color="surface">
                <h3 class="font-weight-medium text-on-surface">Schedule a Call!</h3>

              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-container>

    <v-container fluid class="bg-surface-light">
      <v-container class="text-on-surface-light">
        <v-row>
          <v-col cols="12" lg="6" class="mt-5">
            <div class="text-h4">{{ store.user.first_name }} {{ store.user.last_name }} Age: <b>{{ store.user.age }}</b></div>
            <div class="caption d-block text-no-wrap pr-2">Tax-Deferred Funds for Analysis: <b>{{ formatCurrency(store.user.taxDeferred) }}</b></div>
            <div class="caption d-block text-no-wrap pr-2">Assumed Effective Tax Rate: <b>{{ store.user.taxRate }}%</b></div>
            <div class="caption d-block text-no-wrap pr-2">Assumed Growth Rate for Funds: <b>{{ growRate }}</b></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="8" class="mt-5">
            <p>This analysis is based on the following additional assumptions. Please check your email for your custom, comprehensive report.</p>
            <ul class="my-5 ml-5">
              <li>You continue to keep your IRA, 401(k), or other qualified account</li>
              <li>You take Required Minimum Distributions (RMDs) when required</li>
              <li>You reinvest those RMDs in a taxable account earning an equivalent after-tax rate</li>
              <li>You live until age 90</li>
              <li>Your heirs are taxed at the same rate you have selected above</li>
            </ul>
            <p>This is an analysis of the total potential taxes you may pay from your IRA or 401(k), based on what we believe are reasonable, forward-looking assumptions and scenarios. A complete analysis has been emailed to you.</p>
            <p>Next Steps? We're here to help.</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn size="x-large" @click="scheduleAction" color="surface">
              <h3 class="font-weight-medium text-on-surface">Schedule a Call!</h3>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-dialog v-model="beforeExitDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between pa-4">
          Wait!
          <v-btn icon variant="text" @click="beforeExitDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <p>Did you know many experts believe taxes are going UP for retirees?</p>
          <p>See if you'll be impacted – and how much bigger your Retirement Tax Bill could be.</p>
          <v-col class="text-center" cols="12" md="8" offset-md="2">
            <v-btn @click="scheduleAction" rounded="pill" color="primary" size="large">
              <span class="text-on-primary">Schedule a Call</span>
            </v-btn>
          </v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="beforeExitDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import CalcCardCondense from '../components/CalcCardCondense.vue'
import { useLeadGeneratorStore } from '@/stores/leadGenerator'
import { useBranding } from '@/composables/useBranding'
import { buildHeroBackgroundStyle } from '@/utils/heroBackground'
import { formatCurrency } from '@/utils/formatters'
import { resolveEmailBody } from '@/utils/customization'
import fallbackHeroImage from '@/assets/images/TTB_LPHeader_0921.webp'

const BRANDING_API_ORIGIN =
  import.meta.env.VITE_BRANDING_API_ORIGIN || 'https://beta.stonewoodfinancial.com'
const SEND_EMAIL_API_URL = `${BRANDING_API_ORIGIN.replace(/\/$/, '')}/scripts/proposals/rmd/tax-burden-lead-send-email.php`

export default {
  name: 'AnalysisPage',
  components: {
    CalcCardCondense,
  },
  setup() {
    const store = useLeadGeneratorStore()
    const { loadBranding } = useBranding()
    return { store, formatCurrency, loadBranding }
  },
  data: () => ({
    growRate: '6%',
    beforeExitDialog: false,
  }),
  computed: {
    heroBackgroundStyle() {
      return buildHeroBackgroundStyle(
        this.store.customization?.media,
        this.store.heroImageCacheBust,
        fallbackHeroImage
      )
    },
  },
  async mounted() {
    window.scrollTo(0, 0)
    this.store.ensureCustomizationDefaults()

    // Guard: if there is no proposal in state (e.g. user navigated directly
    // or opened a brand-new browser session), send them back to the landing page.
    if (!this.store.user.proposalId) {
      this.$router.replace({ path: '/', query: this.$route.query })
      return
    }

    if (!this.store.customizationLoaded) {
      await this.loadBranding()
    }

    // Exit-intent dialog
    let beforeUnloadTimeout = 0
    this._beforeUnloadHandler = () => {
      beforeUnloadTimeout = setTimeout(() => {
        this.onUnloadCheckUp(true)
      }, 500)
    }
    this._unloadHandler = () => {
      if (beforeUnloadTimeout) {
        clearTimeout(beforeUnloadTimeout)
        beforeUnloadTimeout = 0
      }
    }
    window.addEventListener('beforeunload', this._beforeUnloadHandler)
    window.addEventListener('unload', this._unloadHandler)

    // Only fire the lead-notification email once per proposal,
    // even if the user reloads the Analysis page.
    if (this.store.emailSent) return

    this.store.emailSent = true

    const resolvedEmailBody = resolveEmailBody(
      this.store.customization.email.bodyHtml,
      this.store
    )

    const data = qs.stringify({
      advisorId: this.$route.query.u,
      email: this.store.user.email,
      proposalId: this.store.user.proposalId,
      firstName: this.store.user.first_name,
      attachPdfReport: this.store.customization.email.attachPdfReport ? 1 : 0,
      emailSubject: this.store.customization.email.subject || '',
      emailBody: resolvedEmailBody,
      companyId: this.$route.query.c,
    })

    axios
      .post(SEND_EMAIL_API_URL, data, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
      .catch(() => {
        // Roll back so the next mount attempt can retry
        this.store.emailSent = false
      })
  },
  beforeUnmount() {
    if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler)
    if (this._unloadHandler) window.removeEventListener('unload', this._unloadHandler)
  },
  methods: {
    scheduleAction() {
      window.open(this.store.company.meeting_url, '_blank')
    },
    onUnloadCheckUp(state) {
      this.beforeExitDialog = state
    },
  },
}
</script>